import React, { useState, useEffect } from 'react'
import { Upload, Button } from 'antd'
import { AiOutlineFileImage } from 'react-icons/ai'


const UploadFile = (
    {
        uploadFile,
        multiple,
        typeDoc,
        typeUpload,
        reload  // Sirve para cuando se haya guardado ya los archivos, los borre de la lista
    }
) => {
    const [fileList, setFileList] = useState([])

    useEffect(() => {
        uploadFile(fileList, typeDoc)
    }, [fileList])

    useEffect(() => {
        reloadList()
    }, [reload])

    const reloadList = () => {
        if (reload) {
            setFileList([])
        }
    }

    const onRemove = file => {
        const index = fileList.indexOf(file)
        const newFileList = fileList.slice()
        newFileList.splice(index, 1)
        return setFileList(newFileList)
    }

    const beforeUpload = file => {
        setFileList(fileList => [...fileList, file])
        return false
     }

    const props = {
        beforeUpload: beforeUpload,
        onRemove: onRemove,
        fileList: fileList 
    }

    return (
        <Upload  accept={typeUpload} multiple={multiple} {...props} style={{ width: "100%" }}>
            <Button style={{ width: "100%" }}>
                <AiOutlineFileImage />
                Seleccionar fichero
            </Button>
        </Upload>
    )
}
export default UploadFile


